import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClapboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconClapboard"><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor"/><Path d="M3.5 8.5H20.5" stroke="currentColor"/><Path d="M8.25 8.5L10.25 3.5" stroke="currentColor"/><Path d="M13.75 8.5L15.75 3.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconClapboard;
